export enum VmAdminApprovalStatusEnum {
    None = 'None',
    NeedsApproval = 'NeedsApproval',
    NotApplicable = 'NotApplicable',
    Automatic = 'Automatic',
    Disapproved = 'Disapproved',
    Approved = 'Approved',
}
